import { h, createApp } from 'vue';
import ConfirmationDialog from './ConfirmationDialog.vue'; // Adjust path if needed

function setMountPoint() {
  let mountPoint = document.getElementById('dialog-helper-mount-point');
  if (!mountPoint) {
    mountPoint = document.createElement('div');
    mountPoint.setAttribute('id', 'dialog-helper-mount-point');
    const appElement = document.querySelector('[data-app="true"]');
    if (appElement) {
      appElement.appendChild(mountPoint);
    } else {
      console.warn('[DialogPlugin] Could not find <v-app data-app="true"> element. Dialogs may not render correctly.');
      document.body.appendChild(mountPoint); // Fallback to body
    }
  }
  return mountPoint;
}

/**
 * Reason for creating this, base $dialog.confirm on Vuetify Dialog, does not have full control on buttons
 */
const DialogPlugin = {
  /**
   *
   * @param {import('vue').App} app
   * @param {Object} options
   */
  install(app, options = {}) {
    const vuetifyInstance = options.vuetify;
    if (!vuetifyInstance) {
      console.warn('[DialogPlugin] Vuetify instance is required. Pass it during plugin installation: app.use(DialogPlugin, { vuetify })');
      throw new Error('[DialogPlugin] Vuetify instance is required');
    }

    app.config.globalProperties.$confirm = function(config) {
      return new Promise((resolve) => {
        const mountPoint = setMountPoint();
        const instanceElement = document.createElement('div');
        mountPoint.appendChild(instanceElement);

        // Create the dialog app
        const dialogApp = createApp({
          render() {
            return h(ConfirmationDialog, {
              ...config,
              resolve,
              // Optionally, you can pass $t or other context here if needed
            });
          }
        });

        // Provide Vuetify instance if needed
        if (vuetifyInstance) {
          dialogApp.use(vuetifyInstance);
        }

        // Mount the dialog
        const dialogVm = dialogApp.mount(instanceElement);

        // Cleanup after dialog resolves
        const cleanup = () => {
          setTimeout(() => {
            dialogApp.unmount();
            if (instanceElement.parentNode) {
              instanceElement.parentNode.removeChild(instanceElement);
            }
          }, 500); // Give some time for transitions
        };

        const originalResolve = resolve;
        resolve = (value) => {
          cleanup();
          originalResolve(value);
        };
      });
    };
  },
};

export default DialogPlugin;
